import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Button } from '../Buttons/Button';
import Box from '@mui/system/Box';

const Title = styled(DialogTitle)(({ theme }) => ({
  paddingTop: theme.spacing(16),
  paddingLeft: theme.spacing(20),
}));

const PrimaryTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(10),
}));

const TittleText = styled('span')(() => ({
  '&:first-letter': { textTransform: 'uppercase' },
}));

const Message = styled(DialogContent)(({ theme }) => ({
  paddingLeft: theme.spacing(20),
  paddingRight: theme.spacing(48),
}));

const TypographyMessage = styled(Typography)({
  whiteSpace: 'pre-line',
});

const Actions = styled(DialogActions)(({ theme }) => ({
  paddingTop: theme.spacing(16),
}));

export type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  subTitle?: string;
  onConfirm: () => void;
  onCancel: () => void;
  titleIcon?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  titleTestId?: string;
  cancelButtonTestId?: string;
  confirmButtonTestId?: string;
  confirmButtonsDisabled?: boolean;
} & (
  | {
      message: string | React.ReactNode;
      messageTestId?: string;
    }
  | {
      children?: React.ReactNode;
    }
);

export const ConfirmationDialog = ({
  open,
  title,
  titleIcon,
  subTitle,

  onCancel,
  onConfirm,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  titleTestId = '',
  cancelButtonTestId = '',
  confirmButtonTestId = '',
  confirmButtonsDisabled,
  ...props
}: ConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <Title data-testid={titleTestId}>
        <Box sx={{ lineHeight: 0.8 }}>
          <PrimaryTitle>
            {titleIcon}
            <TittleText>{title}</TittleText>
          </PrimaryTitle>
          {subTitle && (
            <Typography variant="text4" sx={{ mt: -5 }}>
              {subTitle}
            </Typography>
          )}
        </Box>
      </Title>
      {'message' in props ? (
        <Message data-testid={props.messageTestId}>
          <TypographyMessage variant="text1">{props.message}</TypographyMessage>
        </Message>
      ) : (
        <Message>{props.children}</Message>
      )}
      <Actions>
        <Button variant={'secondary'} onClick={onCancel} data-testid={cancelButtonTestId}>
          {cancelButtonText}
        </Button>
        <Button
          variant={'primary'}
          onClick={onConfirm}
          data-testid={confirmButtonTestId}
          disabled={confirmButtonsDisabled}
        >
          {confirmButtonText}
        </Button>
      </Actions>
    </Dialog>
  );
};
